import logo from "@/assets/spotlight-logo.png";
import { cn } from "@/lib/utils";

interface AnimatedLogoProps {
  className?: string;
  size?: number;
}

export const AnimatedLogo = ({ className, size = 40 }: AnimatedLogoProps) => {
  return (
    <div className={cn("relative", className)}>
      <img
        src={logo}
        alt="Spotlight Adz"
        className="animate-spin-slow"
        style={{ width: size, height: size }}
      />
    </div>
  );
};
